export const getters = {
  activeTab: (state) => {
    for (let tab in state.tabs) {
      if (state.tabs[tab].isActive) {
        return state.tabs[tab];
      }
    }
  },
  activeTabIndex: (state) => {
    for (let tab in state.tabs) {
      if (state.tabs[tab].isActive) {
        return tab;
      }
    }
  },
  availableTabs: (state) => {
    let tabs = [];
    for (let tab in state.tabs) {
      // Show tabs without permission field (like Dashboard) to all users
      if (
        !state.tabs[tab].permission ||
        state.user.permissions.includes(state.tabs[tab].permission)
      ) {
        tabs.push(state.tabs[tab]);
      }
    }
    return tabs;
  },
  // Modal Stack Getters
  hasOpenModals: (state) => {
    return state.modalStack.length > 0;
  },
  topModal: (state) => {
    return state.modalStack.length > 0
      ? state.modalStack[state.modalStack.length - 1]
      : null;
  },
  topModalData: (state, getters) => {
    return getters.topModal ? getters.topModal.data : null;
  },
  topModalType: (state, getters) => {
    return getters.topModal ? getters.topModal.type : null;
  },
  topModalActiveTabIndex: (state, getters) => {
    return getters.topModal ? getters.topModal.activeTabIndex : 0;
  },
  modalStackCount: (state) => {
    return state.modalStack.length;
  },
  getModalByType: (state) => (type) => {
    return state.modalStack.find((modal) => modal.type === type);
  },
};
